export class CloseDropEventType {

	static CLOSE_DROP = 'CLOSE_DROP';

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/app.event.type.ts